import { ButtonBase, Tooltip, Typography } from "@mui/material"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faArrowsRotate } from "@fortawesome/pro-light-svg-icons"
import { makeStyles } from "tss-react/mui"

import { useAppLocalization } from "../../../modules/localization/components/AppLocalizationProvider"

const useStyles = makeStyles()((theme) => ({
    button: {
        display: "inline-flex",
        alignItems: "center",
        gap: ".25rem",
        height: "1.375rem",
        marginLeft: ".5rem",
        padding: "0 .5rem",
        borderRadius: "1rem",
        verticalAlign: "middle",
        background: theme.palette.tailwind.sky[50],
        color: theme.palette.tailwind.sky[800],
        "&:hover": {
            background: theme.palette.tailwind.sky[100],
        },
    },
    count: {
        fontWeight: theme.typography.fontWeightMedium,
        lineHeight: 1,
    },
}))

type Props = Readonly<{
    count?: number
    onClick: () => void
}>

export function RecurrenceSeriesButton({ count, onClick }: Props) {
    const { classes } = useStyles()
    const { l10n } = useAppLocalization()
    const label = l10n.getString("meeting-service-recurrence-series-button-tooltip")

    return (
        <Tooltip arrow title={label}>
            <ButtonBase className={classes.button} aria-label={label} onClick={onClick}>
                <FontAwesomeIcon icon={faArrowsRotate} size="sm" />
                {count != null && (
                    <Typography component="span" variant="caption" className={classes.count}>
                        {count}
                    </Typography>
                )}
            </ButtonBase>
        </Tooltip>
    )
}
